<template>
  <div class="page-header">
    <div class="header-content">
      <div class="title-section">
        <div class="title-row">
          <div class="title-with-icon">
            <img src="@/assets/images/icon/icon-gauge.svg" alt="성과 아이콘" class="title-icon" />
            <h1 class="page-title">성과예측 대시보드</h1>
          </div>
        </div>
        <div class="description-row">
          <p class="page-description">구성원의 성과를 FOCUS 모델로 분석하고 예측합니다.</p>
        </div>
      </div>

      <!-- 필터 영역 -->
      <div class="filter-section">
        <div class="filter-group">
          <div class="filter-item">
            <label class="filter-label">연도</label>
            <UiSelect v-model="selectedYear" :options="yearOptions" class="filter-select w-120" @change="handleYearChange" />
          </div>
          <div class="filter-item">
            <label class="filter-label">월</label>
            <UiSelect v-model="selectedMonth" :options="monthOptions" class="filter-select w-120" />
          </div>
        </div>
        <div class="filter-actions">
          <UiButton variant="primary" @click="handleSearch">
            <i class="icon icon-search icon-md icon-white"></i>
            검색
          </UiButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { usePaDashboardStore } from '~/composables/pa/dashboard/usePaDashboardStore';

// Store 가져오기
const $store = usePaDashboardStore();

// Props 정의
const props = defineProps({
  yearOptions: {
    type: Array,
    default: () => [
      { label: '2025', value: '2025' },
      { label: '2024', value: '2024' },
      { label: '2023', value: '2023' },
    ],
  },
  monthOptions: {
    type: Array,
    default: () => [
      { label: '1월', value: '01' },
      { label: '2월', value: '02' },
      { label: '3월', value: '03' },
      { label: '4월', value: '04' },
      { label: '5월', value: '05' },
      { label: '6월', value: '06' },
      { label: '7월', value: '07' },
      { label: '8월', value: '08' },
      { label: '9월', value: '09' },
      { label: '10월', value: '10' },
      { label: '11월', value: '11' },
      { label: '12월', value: '12' },
    ],
  },
  departmentOptions: {
    type: Array,
    default: () => [
      { label: '전체 부서', value: 'all' },
      { label: '개발팀', value: 'dev' },
      { label: '영업팀', value: 'sales' },
      { label: '인사팀', value: 'hr' },
      { label: '마케팅팀', value: 'marketing' },
    ],
  },
});

// Emits 정의
const emit = defineEmits(['search']);

// 필터 상태
const selectedYear = defineModel('year', { default: '2025' });
const selectedMonth = defineModel('month', { default: '09' });
const selectedDepartment = defineModel('department', { default: 'all' });
const memberSearch = defineModel('search', { default: '' });

// 이벤트 핸들러
const handleSearch = () => {
  emit('search', {
    year: selectedYear.value,
    month: selectedMonth.value,
    department: selectedDepartment.value,
    search: memberSearch.value,
  });
};

// 년도 변경 핸들러 - store의 월 옵션 재조회
const handleYearChange = async () => {
  await $store.fetchMonthOptions();
};
</script>

<style scoped lang="scss">
.page-header {
  margin-bottom: 24px;
  background: none;
  border: none;
  padding: 0;

  .header-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .title-section {
      display: flex;
      flex-direction: column;
      gap: 4px;

      .title-row {
        display: flex;
        align-items: center;
        height: 30px;

        .title-with-icon {
          display: flex;
          align-items: center;
          gap: 4px;

          .title-icon {
            width: 20px;
            height: 20px;
          }

          .page-title {
            font-size: 20px;
            font-weight: 700;
            color: #1e2124;
            margin: 0;
          }
        }
      }

      .description-row {
        .page-description {
          font-size: 14px;
          color: #004f99;
          margin: 0;
        }
      }
    }

    .filter-section {
      background: white;
      border: 1px solid #cdd1d5;
      border-radius: 4px;
      padding: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0px;

      .filter-group {
        display: flex;
        align-items: center;
        gap: 16px;

        .filter-item {
          display: flex;
          align-items: center;
          gap: 8px;

          .filter-label {
            font-size: 18px;
            font-weight: 700;
            color: #1e2124;
          }

          .filter-select {
            width: 120px;
          }

          .filter-input {
            width: 200px;
          }
        }
      }

      .filter-actions {
        display: flex;
        gap: 8px;
        padding: 0;
      }
    }
  }
}
</style>
